import { RequestStatusId } from './request-status.constants';

/**
 * Статусы, из которых заказчику (не сотруднику главной компании из настроек заявок)
 * запрещена смена статуса заявки (SYST-3029)
 */
export const CUSTOMER_LOCKED_REQUEST_STATUS_IDS: readonly RequestStatusId[] = [
  RequestStatusId.COMPLETED,
  RequestStatusId.DONE,
];

/**
 * Запрещена ли заказчику смена статуса заявки (SYST-3029):
 * из "Выполнено"/"Выдано" нельзя никуда, кроме повторной установки того же статуса
 * и штатного завершения "Выдано" -> "Выполнено". Сотруднику главной компании разрешено всё.
 */
export function isStatusChangeForbiddenForCustomer(
  currentStatusId: number | null | undefined,
  newStatusId: number | null | undefined,
  isDefaultCounterpartyEmployee: boolean,
): boolean {
  if (
    isDefaultCounterpartyEmployee ||
    currentStatusId == null ||
    !CUSTOMER_LOCKED_REQUEST_STATUS_IDS.some(
      statusId => statusId === currentStatusId,
    ) ||
    currentStatusId === newStatusId
  ) {
    return false;
  }

  return !(
    currentStatusId === RequestStatusId.DONE &&
    newStatusId === RequestStatusId.COMPLETED
  );
}

export function buildStatusChangeForbiddenMessage(
  requestNumber: string,
  currentStatusName: string,
  newStatusName: string,
): string {
  return `Заявка ${requestNumber} в статусе "${currentStatusName}" не может быть переведена в статус "${newStatusName}". Изменить статус выполненной или выданной заявки может только исполнитель. Для изменения обратитесь к вашему менеджеру.`;
}
